import { Box, Paper, Stack, Tab, Tabs } from '@mui/material'
import { CheckPoint } from 'interface'
import { DivIcon, Icon, IconOptions } from 'leaflet'
import { useEffect, useMemo, useState } from 'react'
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMapEvents,
} from 'react-leaflet'
import './leaflet.css'
import { iconChecked, iconCheckpoint } from './MakeIcon'

const zoom = 17

interface LocationProps {
  icon?: Icon<IconOptions> | DivIcon
  position?: { lat: number; lng: number }
  center?: boolean
  checkpoint?: CheckPoint
  setPosition?: (position: { lat: number; lng: number }) => void
}

function LocationMarker({
  position,
  center = false,
  checkpoint,
  icon = iconCheckpoint,
}: LocationProps) {
  const map = useMapEvents({})
  useEffect(() => {
    if (center && position) {
      map.flyTo(
        {
          lat: position.lat,
          lng: position.lng,
        },
        zoom
      )
    }
  }, [center, map, position])

  return position ? (
    <Marker position={position} icon={icon}>
      {checkpoint && (
        <Popup closeOnClick position={position} offset={[0, -40]}>
          {checkpoint.name}
        </Popup>
      )}
    </Marker>
  ) : null
}

interface Props {
  positions: CheckPoint[]
}
export default function OpenStressMap({ positions }: Props) {
  const [center, setCenter] = useState<{ lat: number; lng: number }>({
    lat: positions[0]?.lat,
    lng: positions[0]?.lng,
  })
  const [cIndex, setCIndex] = useState(0)
  useEffect(() => {
    if (positions[cIndex]) {
      setCenter({
        lat: positions[cIndex].lat,
        lng: positions[cIndex].lng,
      })
    }
  }, [cIndex, positions])
  const map = useMemo(() => {
    return (
      <MapContainer
        center={center}
        zoom={zoom}
        scrollWheelZoom={false}
        style={{ width: '100%', height: '80vh' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {positions.map((v, i) => {
          return (
            <LocationMarker
              key={i}
              center={i === cIndex}
              icon={iconChecked}
              checkpoint={v}
              position={v}
            />
          )
        })}
      </MapContainer>
    )
  }, [cIndex, center, positions])
  if (!center) return null
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setCIndex(newValue)
  }
  return (
    <Paper elevation={4}>
      <Stack>
        <Tabs value={cIndex} onChange={handleChange}>
          {positions.map((v) => {
            return <Tab key={v.id} label={v.name} />
          })}
        </Tabs>
      </Stack>
      <Box
        borderRadius={2}
        overflow="hidden"
        width="100%"
        my={2}
        sx={{
          border: '2px solid',
          borderColor: '#0000',
        }}
      >
        {map}
      </Box>
    </Paper>
  )
}
